// Chinese translations
export const translationsZH = {
  nav: {
    home: "首页",
    icfPlans: "ICF多户住宅规划",
    shop: "商店",
    sixPlex: "6-Plex ICF",
    eightPlex: "8-Plex ICF",
    twelvePlex: "12-Plex ICF",
    townhomes: "ICF联排别墅",
    investors: "投资者与贷方",
    process: "从规划到许可",
    about: "关于我们",
    team: "我们的团队",
    contact: "联系我们",
    blog: "博客"
  },
  hero: {
    headline: "为房地产开发商优化收益的多户住宅设计",
    subheadline: "租金收入最大化。建设成本优化。回报有保障。",
    viewPlans: "查看规划",
    downloadGuide: "下载投资者指南"
  },
  whyUs: {
    title: "为什么选择Plexterra？",
    point1Title: "ICF多户住宅专家",
    point1Text: "在绝缘混凝土模板复式住宅设计方面拥有公认的专业知识。",
    point2Title: "准备适应的规划",
    point2Text: "优化的建筑概念，可适应您的土地和管辖区。",
    point3Title: "SCHL合规",
    point3Text: "符合高能效标准的规划。",
    point4Title: "国际视野",
    point4Text: "为加拿大、美国和国际市场设计。"
  },
  icf: {
    title: "ICF技术：经久耐用",
    benefit1Title: "100+年耐久性",
    benefit1Text: "耐候耐火的钢筋混凝土结构。",
    benefit2Title: "能源效率",
    benefit2Text: "R-22至R-50绝缘，节能高达50%。",
    benefit3Title: "风险降低",
    benefit3Text: "索赔更少，保险费最高降低25%。",
    benefit4Title: "ESG价值",
    benefit4Text: "碳足迹减少，符合可持续标准。",
    learnMore: "了解更多关于ICF"
  },
  plans: {
    title: "可用的多户住宅规划",
    subtitle: "优化概念以最大化每平方英尺回报",
    viewPlan: "查看规划",
    idealFor: "适合",
    urbanLots: "城市地块",
    midSize: "中型项目",
    largeScale: "大型项目",
    rowHouses: "联排房屋"
  },
  esg: {
    title: "可持续性与融资：ESG优势",
    text: "我们的ICF规划旨在满足日益增长的可持续性要求。SCHL合规和ESG特性有助于：",
    point1: "获得银行融资",
    point2: "绿色项目优惠利率",
    point3: "政府补贴资格",
    point4: "资产长期增值",
    viewSheet: "查看投资者资料"
  },
  cta: {
    title: "准备好投资明天的房地产了吗？",
    card1Title: "查看规划",
    card1Text: "探索我们的6-plex、8-plex和12-plex概念。",
    card1Button: "商店",
    card2Title: "投资者指南",
    card2Text: "下载我们的完整文档。",
    card2Button: "下载 (PDF)",
    card3Title: "联系我们",
    card3Text: "让我们讨论您的投资项目。",
    card3Button: "联系"
  },
  icfPage: {
    h1: "面向投资者的ICF多户住宅规划",
    subtitle: "机构级建筑概念，针对财务绩效和可持续性进行优化。",
    whatIsIcf: "什么是ICF？",
    icfExplanation: "绝缘混凝土模板（ICF）是一种建筑系统，其中发泡聚苯乙烯块用作钢筋混凝土的永久模板。这项技术提供卓越的隔热性能和无与伦比的耐久性。",
    whyInvestorsTitle: "为什么投资者选择ICF",
    reducedCosts: "降低运营成本",
    reducedCostsPoints: ["供暖/制冷节省40-50%", "结构维护更少", "100+年使用寿命"],
    riskReduction: "风险降低",
    riskReductionPoints: ["4小时防火等级（木材为1小时）", "抗极端天气", "保险费最高降低25%"],
    betterFinancing: "更好的融资",
    betterFinancingPoints: ["贷方看重的ESG合规", "绿色项目资格", "更高的转售价值"],
    rentalStability: "租赁稳定性",
    rentalStabilityPoints: ["卓越的隔音舒适度", "能源账单减少", "现代可持续形象"],
    comparisonTitle: "ICF与木结构对比",
    criteria: "标准",
    woodFrame: "木结构",
    lifespan: "使用寿命",
    years: "年",
    insulation: "绝缘（R值）",
    fireResistance: "防火性能",
    hours: "小时",
    hour: "小时",
    energyCosts: "能源成本",
    baseline: "基准",
    maintenance: "结构维护",
    minimal: "最小",
    moderate: "中等",
    insurancePremium: "保险费",
    soundproofing: "隔音",
    excellent: "优秀",
    poor: "差",
    resaleValue: "转售价值",
    higher: "更高",
    standard: "标准",
    availableFormats: "可用格式",
    importantNotice: "重要通知",
    noticeText: "我们的规划是建筑概念，需要当地建筑师进行调整以：符合您所在地区的建筑法规、适应您的土地特征、并由持证工程师认证。Plexterra不是总承包商。我们设计规划，由您提供给您选择的专业人员。"
  },
  investors: {
    h1: "面向投资者和贷方",
    subtitle: "银行级文档，助您做出明智决策。",
    whyBankable: "为什么这些项目具有融资价值",
    icfAdvantages: "ICF结构优势",
    icfPoints: ["100+年耐久性降低长期风险", "防火防风减少索赔", "更低保险费改善NOI"],
    financialPerformance: "财务绩效",
    financialPoints: ["40-50%能源节省增加NOI", "建筑生命周期内维护成本更低", "舒适度带来更高租户留存率"],
    esgTitle: "ESG与可持续性",
    esgPoints: ["碳足迹减少符合ESG要求", "SCHL合规满足绿色融资标准", "应对未来能源法规收紧"],
    rentalTitle: "租赁稳定性",
    rentalPoints: ["卓越隔音 = 更满意的租户", "更低公用事业成本 = 有竞争力的租金", "现代建筑 = 优质定位"],
    keyMetrics: "关键指标",
    downloadPack: "下载投资者资料包"
  },
  process: {
    h1: "从规划到许可",
    subtitle: "简化流程，实现您的投资项目。",
    step1Title: "规划选择",
    step1Text: "根据您的投资目标，从我们的ICF 6-plex、8-plex、12-plex或联排别墅概念中选择。",
    step2Title: "概念购买",
    step2Text: "购买完整套餐，包括建筑规划、技术文档和适应指南。",
    step3Title: "本地适应",
    step3Text: "您的建筑师将概念调整适应您的土地和当地建筑法规要求。",
    step4Title: "认证",
    step4Text: "持证工程师认证适应您所在地区的结构规划。",
    step5Title: "建筑许可",
    step5Text: "向您的市政府提交认证规划以获得建筑许可。",
    step6Title: "建设",
    step6Text: "选择合格的ICF承包商，开始您的项目建设。",
    whatIncluded: "购买内容包括",
    includedItems: [
      "详细建筑规划（PDF + CAD）",
      "ICF技术规格",
      "建筑师适应指南",
      "投资者数据表",
      "参考成本估算",
      "电子邮件支持（30天）"
    ],
    startProject: "开始您的项目"
  },
  about: {
    h1: "关于Plexterra",
    subtitle: "您在ICF多户住宅设计方面值得信赖的合作伙伴。",
    missionTitle: "我们的使命",
    missionText: "Plexterra致力于设计机构级ICF多户住宅规划。我们的使命是为房地产投资者提供针对财务绩效和环境可持续性优化的建筑概念。",
    expertiseTitle: "我们的专长",
    expertiseText: "专注于绝缘混凝土模板（ICF），我们将建筑创新与财务严谨相结合，创建满足最苛刻投资者和贷方要求的规划。",
    valuesTitle: "我们的价值观",
    value1Title: "卓越",
    value1Text: "机构级规划，可向任何银行信贷委员会展示。",
    value2Title: "创新",
    value2Text: "尖端ICF技术，实现最大耐久性和效率。",
    value3Title: "透明",
    value3Text: "完整真实的文档，没有夸大的承诺。",
    value4Title: "可持续性",
    value4Text: "致力于ESG标准和负责任的建筑。",
    marketsTitle: "我们的市场",
    marketsText: "我们的规划设计为可适应加拿大、美国和国际市场，特别关注各管辖区的建筑法规和融资要求。"
  },
  contact: {
    h1: "联系我们",
    subtitle: "让我们讨论您的多户住宅投资项目。",
    formTitle: "发送消息",
    name: "全名",
    email: "电子邮件",
    phone: "电话（可选）",
    company: "公司（可选）",
    projectType: "项目类型",
    selectProject: "选择项目类型",
    project6plex: "6-Plex ICF",
    project8plex: "8-Plex ICF",
    project12plex: "12-Plex ICF",
    projectTownhomes: "ICF联排别墅",
    projectOther: "其他",
    message: "消息",
    messagePlaceholder: "描述您的投资项目...",
    submit: "发送消息",
    sending: "发送中...",
    successTitle: "消息已发送！",
    successText: "我们将在24-48小时内回复您。",
    infoTitle: "信息",
    responseTime: "响应时间：24-48小时",
    languages: "语言：Français, English, Español, العربية, 中文",
    markets: "市场：加拿大、美国、国际"
  },
  product: {
    from: "起价",
    addToCart: "订购此规划",
    features: "特点",
    specifications: "技术规格",
    units: "单元",
    floors: "楼层",
    sqft: "面积",
    fireRating: "防火等级",
    rValue: "R值",
    included: "包含内容",
    includedItems: [
      "详细建筑规划（PDF + CAD）",
      "ICF技术规格",
      "建筑师适应指南",
      "投资者数据表",
      "电子邮件支持（30天）"
    ],
    disclaimer: "注意：这些规划是建筑概念，需要当地持证建筑师进行调整。"
  },
  footer: {
    tagline: "Multiplex Designs for Developers",
    quickLinks: "快速链接",
    legal: "法律",
    legalNotice: "法律声明",
    privacyPolicy: "隐私政策",
    termsOfSale: "销售条款",
    newsletter: "新闻通讯",
    newsletterText: "接收我们的最新消息和优惠。",
    subscribe: "订阅",
    subscribing: "订阅中...",
    subscribed: "已订阅！",
    emailPlaceholder: "您的电子邮件",
    rights: "保留所有权利。"
  },
  blog: {
    title: "博客",
    subtitle: "关于ICF房地产投资的文章和指南",
    readMore: "阅读更多",
    backToBlog: "返回博客",
    publishedOn: "发布于",
    category: "类别",
    relatedArticles: "相关文章"
  }
};
